import classNames from "classnames";
import { FC, ReactNode } from "react";

type HeroCardProps = {
  label?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  circleClassName?: string;
};

const HeroCard: FC<HeroCardProps> = ({ label, title, subtitle, className, circleClassName = "bg-background-primary" }) => {
  return (
    <div
      className={classNames(
        "bg-background-primary-dark relative flex h-40 w-64 flex-col justify-between overflow-hidden rounded-lg p-5 text-white shadow-lg",
        className,
      )}
    >
      <div className={classNames("absolute -end-10 -top-16 aspect-square w-48 rounded-full", circleClassName)} />
      {label && <div className="z-10 text-xs font-semibold uppercase tracking-widest">{label}</div>}
      {label && <div className="bg-background-primary-lighter rounded-xs z-10 h-6 w-9 opacity-80" />}
      {(title || subtitle) && (
        <div className="z-10 flex flex-col">
          <span className="text-base font-bold">{title}</span>
          <span className="text-xs opacity-80">{subtitle}</span>
        </div>
      )}
    </div>
  );
};

export default HeroCard;
